import React from "react";
import { Dropdown, Nav, Navbar } from "rsuite";
import "./Navbar.scss";
import logo from "assets/logo.png";
import { IoIosArrowBack, IoIosHome } from "react-icons/io";
import { Link } from "react-router-dom";

import { PanelUserAccessScope } from "@bprotsyk/aso-core";

export enum NavbarTab {
  INDEX = 'index',
  CONSTRUCTOR_FLASH = 'constructor_flash',
  AUTH = 'auth',
  OFFERS = 'offers',
  DOMAINS = 'domains',
  APPS_INFO = 'app-info',
  APPS = 'apps',
  OFFER_LISTS = 'offer-lists'
}

interface AppHubNavbarProps {
  tab: NavbarTab;
  // config: DefaultConfig,
  // configs: DefaultConfig[],
  // onConfigChange: (config: DefaultConfig) => void
}

export default (props: AppHubNavbarProps) => {
  let { tab } = props;
  const rawRoles = localStorage.getItem('userRole');
  let parsedRoles: number[] = [];
  try {
    const raw = rawRoles ? JSON.parse(rawRoles) as any[] : [];
    parsedRoles = Array.isArray(raw) ? raw.map((r) => Number(r)) : [];
  } catch (_) {
    parsedRoles = [];
  }
  const isAdmin = parsedRoles.includes(PanelUserAccessScope.ADMIN as unknown as number);
  const isManager = parsedRoles.includes(PanelUserAccessScope.MANAGER as unknown as number);
  const isDeployer = parsedRoles.includes(PanelUserAccessScope.DEPLOYER as unknown as number);
  const isTester = parsedRoles.includes(PanelUserAccessScope.TESTER as unknown as number);
  const isDeployerOnly = isDeployer && !isAdmin && !isManager;
  const isTesterOnly = isTester && !isAdmin && !isManager && !isDeployer;

  // let dropdownItems: any[] = []
  // configs.forEach((c) => {
  //   if (c.id == config?.id) return

  //   dropdownItems.push(
  //     <Dropdown.Item eventKey={c?.id}>#{c?.id} <code>{c?.bundle}</code></Dropdown.Item>
  //   )
  // })

  return (
    <Navbar>
      <Navbar.Brand className="brand">
        <img src={logo} className="logo" />
      </Navbar.Brand>
      <Nav activeKey={tab.toString()}>
        <Nav.Item href="apps" eventKey={NavbarTab.APPS.toString()}>
          Додатки
        </Nav.Item>
        <Nav.Item href="domains" eventKey={NavbarTab.DOMAINS.toString()}>
          Домени
        </Nav.Item>
      </Nav>

      {/* // picker appok prosto ohuenniy realno topoviy */}
      {/* <Nav pullRight>
        <Dropdown className="app-picker" placement='bottomEnd' onSelect={(key: string) => {
          let config = configs.find((c) => c.id == parseInt(key))
          if (config) onConfigChange(config)
        }} trigger="click" title={<span><b className="app-id">#{config?.id}</b> <code>{config?.bundle}</code></span>}>
          {dropdownItems}
        </Dropdown>
      </Nav> */}
    </Navbar>
  );
};
